import React from "react";
import { NodeProps, Position } from "@xyflow/react";
import { RiCheckDoubleLine } from "@remixicon/react";
import classNames from "classnames";
import Styles from "./Nodes.module.scss";
import BaseHandle from "../BaseHandle";
import Icon from "../../../theme/icon/Icon";
import { ACTION } from "../../workflow/constants";
import { WorkflowStep } from "../../../../__generated__/api";

export default function InitialActionNode(props: NodeProps) {
    const { id, data: step, type } = props;
    const title = type === ACTION.GENERIC_NO_TICKET ? "Started" : (step as WorkflowStep).name;

    return (
        <>
            <div
                id={id}
                className={classNames(Styles["request-created-node"], "nonDraggableNode")}
            >
                <Icon icon={<RiCheckDoubleLine className={Styles["request-created-node-icon"]} />} />
                <p>{title}</p>
            </div>
            <BaseHandle type="source" position={Position.Right} id="b" />
        </>
    );
}
